export const testimonials = [
  {
    id: 1,
    name: "Rabien Ustoc",
    role: "Cực kỳ hài lòng",
    avatar: "https://i.pravatar.cc/150?u=rabien",
    content: "Dịch vụ thuê thiết bị của GearXpert quá đỉnh! Thiết bị được bảo trì tốt, sạch bóng, lại còn chạy êm như ru. Đúng kiểu chỉ cần thuê là thấy như đang được hỗ trợ chuyên nghiệp nhất.",
  },
  {
    id: 2,
    name: "Thanh Vân",
    role: "Cực kỳ hài lòng",
    avatar: "https://i.pravatar.cc/150?u=thanhvan",
    content: "Dịch vụ thuê thiết bị của GearXpert quá đỉnh! Thiết bị được bảo trì tốt, sạch bóng, lại còn chạy êm như ru. Đúng kiểu chỉ cần thuê là thấy như đang được hỗ trợ chuyên nghiệp nhất.",
  },
  {
    id: 3,
    name: "Minh Hoàng",
    role: "Rất hài lòng",
    avatar: "https://i.pravatar.cc/150?u=minhhoang",
    content: "Tôi thường xuyên thuê máy ảnh ở đây cho các buổi chụp lookbook. Quy trình nhận máy nhanh gọn, nhân viên tư vấn nhiệt tình. Rất an tâm khi sử dụng dịch vụ.",
  },
  {
    id: 4,
    name: "Linh Chi",
    role: "Xuất sắc",
    avatar: "https://i.pravatar.cc/150?u=linhchi",
    content: "Hệ thống SmartGear AI gợi ý combo rất chuẩn xác cho nhu cầu quay vlog của tôi. Tiết kiệm được rất nhiều thời gian lựa chọn thiết bị lẻ tẻ.",
  }
];
